import { Trace } from '@uniswap/analytics'
import { PageName } from '@uniswap/analytics-events'
import { Currency, TradeType } from '@uniswap/sdk-core'
import { Widget } from 'components/Widget/Widget'
import { ReactNode } from 'react'
import { InterfaceTrade } from 'state/routing/types'
import { TradeState } from 'state/routing/types'
import styled from 'styled-components/macro'

import { PageWrapper } from '../../components/swap/styleds'
import { SwitchLocaleLink } from '../../components/SwitchLocaleLink'

const WidgetContainer = styled.div`
  height: 501px;
  width: 440px;
`

export function getIsValidSwapQuote(
  trade: InterfaceTrade<Currency, Currency, TradeType> | undefined,
  tradeState: TradeState,
  swapInputError?: ReactNode
): boolean {
  return !!swapInputError && !!trade && (tradeState === TradeState.VALID || tradeState === TradeState.SYNCING)
}

export default function Swap() {
  return (
    <Trace page={PageName.SWAP_PAGE} shouldLogImpression>
      <>
        <PageWrapper>
          {/* <SwapWrapper id="swap-page"> */}
          {/* <WidgetContainer> */}
          <Widget />
          {/* </SwapWrapper> */}
        </PageWrapper>
        <SwitchLocaleLink />
      </>
    </Trace>
  )
}
